import React, { useState, useRef } from 'react';
import { useToggle } from 'react-use';
import { useTranslation } from 'react-i18next';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import filter from 'lodash/filter';
import cn from 'classnames';
import findIndex from 'lodash/findIndex';

import FileViewer from '@components/snippets/FileViewer';
import Card from '@components/snippets/Card';
import ContentItem from './ContentItem';
import ContentFilter from '@components/snippets/ContentFilter';
import Empty from '@components/snippets/Empty';
import Loader from '@components/snippets/Loader';
import useFilterContentByType, {
  Filter,
} from '../../../hooks/useFilterContentByType';

function ContentList({
  loading,
  content = [],
  onDelete,
  sort,
  onSort,
  onSearch,
}) {
  const [showImage, toggleImage] = useToggle(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    t,
    content: items,
    lightboxImages,
    activeTab,
    tabList,
    onChange,
  } = useFilterContentByType({
    content,
  });
  const onShow = (index) => () => {
    setActiveIndex(index);
    toggleImage();
  };
  const showContent = !isEmpty(items) || loading;

  const emptyText =
    activeTab === Filter.ALL
      ? t('empty-dir')
      : activeTab === Filter.IMAGE
      ? `${t('empty-dir')} ${t('upload-first-image')}`
      : activeTab === Filter.LINK
      ? `${t('empty-dir')} ${t('upload-first-link')}`
      : `${t('empty-dir')} ${t('upload-first-video')}`;

  return (
    <div className="scroll-with-padding">
      {[
        showImage && (
          <FileViewer
            currentIndex={activeIndex}
            visible={showImage}
            onClose={toggleImage}
            files={lightboxImages}
            onDelete={onDelete(get(content, [activeIndex, 'id']))}
          />
        ),
        <Card
          className={cn('content-list', {
            'content-list--empty': !showContent,
          })}
          tabList={tabList}
          activeTabKey={activeTab}
          onTabChange={onChange}
          extra={
            <ContentFilter
              sort={sort}
              onSort={onSort}
              onSearch={onSearch}
              className="content-list__extra"
            />
          }
        >
          {showContent ? (
            <div className="content-list__body">
              <Loader loading={loading} />
              {map(items, (contentItem, index) => (
                <ContentItem
                  key={index}
                  t={t}
                  onShow={onShow(
                    findIndex(lightboxImages, ({ id }) => id === contentItem.id)
                  )}
                  onDelete={onDelete(contentItem.id)}
                  {...contentItem}
                />
              ))}
            </div>
          ) : (
            <Empty text={emptyText} />
          )}
        </Card>,
      ]}
    </div>
  );
}

export default ContentList;
